let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hQkGr")).then(() => parcelRequire('aQ86W'));